import axios from '@axios'

const PREFIX = '/checklists-honorarios'

export default {
  getChecklistHonorarios(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  existeChecklistHonorario() {
    return axios.get(`${PREFIX}/existe-checklist`)
  },

  deleteChecklistHonorarios(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getChecklistHonorario(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  getParametrizacaoChecklistCopia(id) {
    return axios.get(`${PREFIX}/copia?id=${id}`)
  },

  salvarParametrizacaoChecklist(copia, checklistHonorarios) {
    return axios.post(`${PREFIX}/add?copia=${copia}`, checklistHonorarios)
  },

  updateParametrizacaoChecklist(id, checklistHonorarios) {
    return axios.put(`${PREFIX}/${id}`, checklistHonorarios)
  },

  getTributacoesCadastradasChecklist() {
    return axios.get(`${PREFIX}/tributacoes-existentes`)
  },

  deleteParametrizacaoChecklistHonorarios(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getTributacoesCadastradasChecklistFilial(somenteFilial, tipoProposta, externo = false) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-proposta/tributacoes-filial?filial=${somenteFilial}&tipoProposta=${tipoProposta}`)
    }
    return axios.get(`${PREFIX}/tributacoes-filial?filial=${somenteFilial}&tipoProposta=${tipoProposta}`)
  },

  getAtividadesCadastradasChecklist(tributacao, somenteFilial, tipoProposta, externo = false) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-proposta/atividades?tributacaoId=${tributacao}&filial=${somenteFilial}&tipoProposta=${tipoProposta}`)
    }
    return axios.get(`${PREFIX}/atividades?tributacaoId=${tributacao}&filial=${somenteFilial}&tipoProposta=${tipoProposta}`)
  },

  getChecklist(somenteFilial, tributacao, atividade, tipoProposta, externo = false) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-proposta/itens-checklist?filial=${somenteFilial}&tributacaoId=${tributacao}&atividadeId=${atividade}&tipoProposta=${tipoProposta}`)
    }
    return axios.get(`${PREFIX}/itens-checklist?filial=${somenteFilial}&tributacaoId=${tributacao}&atividadeId=${atividade}&tipoProposta=${tipoProposta}`)
  },
}
